export const selectInteractionData = (state, id) => {
    return state.newInteractions[id];
};
export const selectNote = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.note;
};
export const selectUploadedFiles = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.uploadedFiles || [];
};
export const selectLetter = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.letter || {};
};
export const selectEBoks = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.eboks || {};
};
export const selectEmail = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.email || {};
};
export const selectPhone = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.phone || {};
};
export const selectSMS = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.sms || {};
};
export const selectAutoCall = (state, id) => {
    const caseInteractions = state.newInteractions[id] || {};
    return caseInteractions.autocall || {};
};
//# sourceMappingURL=selectors.js.map